/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSeedling} from '@fortawesome/pro-duotone-svg-icons';

const EducatorGrowthIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faSeedling} {...props} />
);

export default EducatorGrowthIcon;
